module.exports = __webpack_public_path__ + "static/media/phoenix.14a018c7.png";